import { useTranslation } from 'react-i18next'
import { Machine } from '../../utils/models/Machine'
import './ReportingButtonsLine.scss'
import { Form } from 'react-bootstrap'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../utils/redux/userSlice'
import { ROLES } from 'aw-consts'
import ReportingPdfDownload from '../ReportingPdfDownload/ReportingPdfDownload.component'
import { useTheme } from '../../utils/contexts/ThemeContext'
import { AWSelect } from 'aw-select'

const ReportingButtonsLine = (props: {
  onChangeMachineFilter: (s: any) => void,
  machinesOptions: any[],
  machineSelected: any,
  machine: Machine,
  onClickGenerate: () => void,
  selectedMonth: number,
  selectedYear: number,
  onChangeMonth: (e: any) => void,
  onChangeYear: (e: any) => void,
  itemsChar: string,
  profitsChar: string,
  alarmsChart: string,
  onCheckChange: (e: any) => void,
  errorsMonth: number,
  errorsTotal: number,
  productsMonth: number,
  productsTotal: number,
  productivityMonth: number,
  productivityTotal: number,
  itemsPerDay: { date: string; numItems: number }[]
}) => {
  const { t } = useTranslation();

  const [disabledMachineCombo, setDisabledMachineCombo] = useState(false)
  const user = useSelector(selectUser)
  const theme = useTheme()

  const ObjMonthArray = [
    { label: t('January'), value: 1 },
    { label: t('February'), value: 2 },
    { label: t('March'), value: 3 },
    { label: t('April'), value: 4 },
    { label: t('May'), value: 5 },
    { label: t('June'), value: 6 },
    { label: t('July'), value: 7 },
    { label: t('August'), value: 8 },
    { label: t('September'), value: 9 },
    { label: t('October'), value: 10 },
    { label: t('November'), value: 11 },
    { label: t('December'), value: 12 },
  ]

  const getYears = () => {
    const ObjYearsArray = []

    let year = 2023

    while (year <= new Date().getFullYear()) {
      ObjYearsArray.push({ value: year, label: year.toString() })
      year++
    }

    return ObjYearsArray
  }

  const getMonth = (month: number) => {
    return ObjMonthArray.find((m) => m.value === month)
  }

  const allMachinesCheck = (e: any) => {
    setDisabledMachineCombo((prevValue) => !prevValue)
    props.onCheckChange(e)
  }

    const dark = theme.theme==='dark';

  return (
    <div className="p-2 rounded-1 buttonsReportingContainer">
      <div className="row border-0 ms-2 me-2 mb-1 p-0" style={{ maxWidth: '100%' }}>
        <div className='col-12 col-sm-2 p-0 ps-2 pe-2 mt-1'>
          <AWSelect dark={dark} onChange={props.onChangeMachineFilter} options={props.machinesOptions} value={props.machineSelected} disabled={disabledMachineCombo}/>
        </div>
        {user.role === ROLES.Administrator && <div className='col-12 col-sm-1 p-0 ps-2 pe-2 mt-2'>
          <Form.Check name="allMachines" type="checkbox" label={t('AllMachines')} defaultChecked={false} onClick={allMachinesCheck} />
        </div>}
        {user.role === ROLES.Demo && <div className='col-12 col-sm-1 p-0 ps-2 pe-2 mt-2'></div>}
        <div className='col-12 col-sm-2 p-0 ps-2 pe-2 mt-1'>
          <AWSelect dark={dark} onChange={props.onChangeMonth} options={ObjMonthArray} value={getMonth(props.selectedMonth) ?? ObjMonthArray[0]} />
        </div>
        <div className='col-12 col-sm-2 p-0 ps-2 pe-2 mt-1'>
          <AWSelect dark={dark} onChange={props.onChangeYear} options={getYears()} value={{ label: props.selectedYear.toString(), value: props.selectedYear }} />
        </div>
        <div className="col-12 col-sm-5 text-center text-sm-end mt-1 pe-0">
          <button onClick={props.onClickGenerate} className="btn-Custom btn-IDGreen me-2">
            <i className="bi bi-file-earmark-bar-graph"></i>
          </button>
            <ReportingPdfDownload
              date={`${getMonth(props.selectedMonth)?.label} - ${props.selectedYear.toString()}`}
              alarmsChart={props.alarmsChart}
              profitsChar={props.profitsChar}
              itemsChar={props.itemsChar}
              machine={props.machine}
              errorsMonth={props.errorsMonth}
              errorsTotal={props.errorsTotal}
              productivityMonth={props.productivityMonth}
              productivityTotal={props.productivityTotal}
              productsMonth={props.productsMonth}
              productsTotal={props.productsTotal}
              itemsPerDay={props.itemsPerDay}
            />
        </div>
      </div>
    </div >
  )

}
export default ReportingButtonsLine